import {AddressItemType} from "@twigsby/client-data";
import {AddressType} from "@twigsby/client-data/lib/Types/AddressTypes";
import {Button, ButtonSize, FlexGap, FlexJustify, StackHorizontal} from "@twigsby/frontend-framework";
import React, {useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {AddAddressModal} from "./AddAddress";
import {AddressControlType} from "./AddressControl";
import ImportCsvModal from "./AddressImporter/Modals/ImportCsvModal";
import ImportVcfModal from "./AddressImporter/Modals/ImportVcfModal";

interface AddAddressTypeButtonsType extends AddressControlType {
    size?: ButtonSize;
    addressAddedCallback?: (e: AddressType) => void;
    csvImportedCallback?: (e: Array<AddressType>) => void;
    vcfImportedCallback?: (e: Array<AddressType>) => void;
    hideImportOptions?: boolean;
}

const AddAddressTypeButtons = (props: AddAddressTypeButtonsType) => {
    const { t } = useTranslation();

    const [ addAddressActive, setAddAddressActive ] = useState<boolean>(false);
    const [ importCsvOpen, setImportCsvOpen ] = useState<boolean>(false);
    const [ importVcfOpen, setImportVcfOpen ] = useState<boolean>(false);

    const HandleAddressAdded = async (singleAddress: AddressType) => {
        setAddAddressActive(false);
        if(props.addressAddedCallback) {
            props.addressAddedCallback(singleAddress);
        }
    };

    const HandleCsvImported = async (bulkAddresses: Array<AddressType>) => {
        setAddAddressActive(false);
        if(props.csvImportedCallback) {
            props.csvImportedCallback(bulkAddresses);
        }
    };

    const HandleVcfImported = async (bulkAddresses: Array<AddressType>) => {
        setAddAddressActive(false);
        if(props.vcfImportedCallback) {
            props.vcfImportedCallback(bulkAddresses);
        }
    };

    return (
        <>
            <StackHorizontal gap={FlexGap.ExtraSmall} justify={FlexJustify.Between} fillChildren={true}>
                <Button
                    title={t('address.actions.newAddress')}
                    size={props.size || ButtonSize.Default}
                    onClick={() => setAddAddressActive(true)}
                    squared={true}
                    disabled={props.disabled}
                />
                {!props.hideImportOptions && (
                    <Button
                        title={t('address.actions.importCsv')}
                        size={props.size || ButtonSize.Default}
                        onClick={() => setImportCsvOpen(true)}
                        squared={true}
                        disabled={props.disabled}
                    />
                )}
                {!props.hideImportOptions && (
                    <Button
                        title={t('address.actions.importVcf')}
                        size={props.size || ButtonSize.Default}
                        onClick={() => setImportVcfOpen(true)}
                        squared={true}
                        disabled={props.disabled}
                    />
                )}
            </StackHorizontal>

            <AddAddressModal
                isOpen={addAddressActive}
                closeCallback={() => setAddAddressActive(false)}
                actionedCallback={(address: AddressType) => HandleAddressAdded(address)}
            />

            {!props.hideImportOptions && (
                <ImportCsvModal
                    isOpen={importCsvOpen}
                    closeCallback={() => setImportCsvOpen(false) }
                    actionedCallback={(addresses: Array<AddressType>) => HandleCsvImported(addresses)}
                />
            )}

            {!props.hideImportOptions && (
                <ImportVcfModal
                    isOpen={importVcfOpen}
                    closeCallback={() => setImportVcfOpen(false) }
                    actionedCallback={(addresses: Array<AddressType>) => HandleVcfImported(addresses)}
                />
            )}
        </>
    )
}

export { AddAddressTypeButtons }
